import { render, staticRenderFns } from "./LeadsQuestionsList.vue?vue&type=template&id=77f80e7e&"
import script from "./LeadsQuestionsList.vue?vue&type=script&lang=js&"
export * from "./LeadsQuestionsList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/lead-listing.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports